import { render, staticRenderFns } from "./board_tg.vue?vue&type=template&id=518ff42e&scoped=true"
import script from "./board_tg.vue?vue&type=script&lang=js"
export * from "./board_tg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518ff42e",
  null
  
)

export default component.exports